import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getClinicDentalServiceMasterByClinicId } from "../../../../store/slices/clinicDentalServiceMaster";
import Select from "react-select";

const Dental = ({ handleChange, isClient }) => {
  const [selectedDentalServices, setSelectedDentalServices] = useState([]);
  const [totalAmount, setTotalAmount] = useState(0);
  const { clinicInfo } = useSelector((state) => state.clinic);
  const dispatch = useDispatch();
  const { clinicDentalServiceMasterByClinicId } = useSelector(
    (state) => state.clinicDentalServiceMaster
  );
  const { token } = useSelector((state) => state.auth);
const clinicId =clinicInfo?.[0]?.clinicId ||null;
  useEffect(() => {
    dispatch(
      getClinicDentalServiceMasterByClinicId({
        clinicId,
        token,
      })
    );
  }, [dispatch, clinicId, token]);

  const handleSelectedDentalService = (selectedOptions) => {
    setSelectedDentalServices(selectedOptions || []);
    handleChange(
      (selectedOptions || []).map((option) => ({
        id: option.value,
        name: option.label,
        price: option.price,
        type: option.type,
      })),
      "serviceDetails"
    );
  };

  useEffect(() => {
    if (!selectedDentalServices.length) return;

    const updatedServices = selectedDentalServices.map((option) => {
      const servicePrice =
        clinicDentalServiceMasterByClinicId?.[0]?.services?.find(
          (serv) => serv._id === option.value
        );

      return {
        ...option,
        price:
          isClient === "Yes"
            ? servicePrice?.client_price
            : servicePrice?.pt_price,
      };
    });

    setSelectedDentalServices(updatedServices);

    handleChange(
      updatedServices.map((option) => ({
        id: option.value,
        name: option.label,
        price: option.price,
        type: option.type,
      })),
      "serviceDetails"
    );
  }, [isClient]);

  useEffect(() => {
    const totalAmount = selectedDentalServices?.reduce((sum, option) => {
      return sum + (option.price || 0);
    }, 0);

    setTotalAmount(totalAmount);
  }, [selectedDentalServices]);

  return (
    <>
      <div className="col-xl-6">
        <div className="form-group">
          <label htmlFor="name" className="col-form-label">
            Service Details:
          </label>
          <Select
            options={clinicDentalServiceMasterByClinicId?.[0]?.services
              ?.filter((servicedetails) => servicedetails.status === "Active")
              ?.map((servicedetails) => ({
                value: servicedetails?._id,
                label: servicedetails?.serviceDetailName,
                type: "dental",
                price:
                  isClient === "Yes"
                    ? servicedetails?.client_price
                    : servicedetails?.pt_price,
              }))}
            value={selectedDentalServices}
            onChange={handleSelectedDentalService}
            isMulti
            styles={{
              container: (provided) => ({ ...provided, marginTop: 8 }),
            }}
          />
        </div>
      </div>
      <div className="col-xl-6">
        <div className="form-group">
          <label htmlFor="total-amount" className="col-form-label">
            Total Amount:
          </label>
          <input
            type="number"
            className="form-control"
            id="total-amount"
            value={totalAmount}
            readOnly
          />
        </div>
      </div>
    </>
  );
};

export default Dental;
